var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider, } from 'react-query';
import { warnDeprecated } from '../../utils/warnDeprecated';
import { MaestroQueryClientContext, useMaestroQueryClientContext } from './MaestroQueryClientContext';
/**
 * `createQueryClient` allows us to be friendly to deprecated query
 * client configuration props as well as the new configuration prop
 */
var createQueryClient = function (props) {
    if (props.queryClientConfig) {
        return new QueryClient(props.queryClientConfig);
    }
    warnDeprecated('Configure `MaestroQueryClientProvider` with the `queryClientConfig` prop instead');
    return new QueryClient({
        queryCache: props.queryCache,
        mutationCache: props.mutationCache,
        defaultOptions: props.defaultOptions,
    });
};
export var MaestroQueryClientProvider = function (propsWithChildren) {
    var contextSharing = propsWithChildren.contextSharing, baseURL = propsWithChildren.baseURL, children = propsWithChildren.children, props = __rest(propsWithChildren, ["contextSharing", "baseURL", "children"]);
    var contextValue = useMaestroQueryClientContext({ baseURL: baseURL });
    var client = useMemo(function () { return createQueryClient(props); }, [props]);
    return (React.createElement(QueryClientProvider, { client: client, contextSharing: contextSharing },
        React.createElement(MaestroQueryClientContext.Provider, { value: contextValue }, children)));
};
//# sourceMappingURL=MaestroQueryClientProvider.js.map